<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-container">

  <!-------------------------------------->
  <!-- Content Section-->
  <!-------------------------------------->

  <div mat-dialog-content>
    <div class="clearfix flex flex-column">

      <!---------------------------->
      <!--  Payment Type -->
      <!---------------------------->

      <ng-container [ngSwitch]=paymentTypeFamily>
        <ng-container *ngSwitchCase="PaymentTypeEnum.Upfront">
          <app-element-select class="w-90 m-b-10"
                              displayLabel='Payment Type'
                              [emitNameValueDTO]="true"
                              [disabled]="disabledPaymentType"
                              [defaultValue]="defaultPaymentType"
                              [options]="paymentTypeLookUpValues">
          </app-element-select>
        </ng-container>

        <ng-container *ngSwitchCase="PaymentTypeEnum.Refund">
          <app-element-select class="w-90 m-b-10"
                              displayLabel='Payment Type'
                              [emitNameValueDTO]="true"
                              [disabled]="disabledPaymentType"
                              [defaultValue]="defaultPaymentType"
                              [options]="refundPaymentDialogOptions"
                              (selectionChanged)="onPaymentTypeSelectionChanged($event)">
          </app-element-select>
        </ng-container>

        <ng-container *ngSwitchCase="PaymentTypeEnum.Duplicate">
          <app-element-select class="w-90 m-b-10"
                              displayLabel='Payment Type'
                              [emitNameValueDTO]="true"
                              [disabled]="disabledPaymentType"
                              [defaultValue]="defaultPaymentType"
                              [options]="paymentTypeLookUpValues">
          </app-element-select>
        </ng-container>
      </ng-container>

      <!---------------------------->
      <!-- Payment Execution Date -->
      <!---------------------------->
      <div class="md-col md-col-12 m-b-10">
        <mat-form-field>
          <mat-label>{{executionDateHeading}}</mat-label>
          <input [formControl]="executionDateFormControl"
                 [min]="minimumExecutionDate()" [matDatepicker]="executionDatePicker" matInput required
                 (dateChange)="onExecutionDateChanged()">
          <mat-datepicker-toggle [for]="executionDatePicker" matIconSuffix>
          </mat-datepicker-toggle>
          <mat-datepicker #executionDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <!---------------------------->
      <!--  Case Name -->
      <!---------------------------->
      <div class="md-col md-col-12 m-b-15">
        <mat-form-field>
          <mat-label>Case Name</mat-label>
          <input required matInput type="text" placeholder="Search by case name OR case ID OR member last name"
                 [formControl]="caseNameFormControl"
                 [matAutocomplete]="caseAuto"
                 (blur)="onBlurCaseName()"
                 (input)="caseNameTextChanged$.next($any($event.target).value)">
          <mat-autocomplete #caseAuto="matAutocomplete" [panelWidth]="'40vw'">
            <mat-option class="custom-mat-option"
                        *ngFor="let caseDTO of filteredCases"
                        [value]="getCaseDisplayString(caseDTO)"
                        (onSelectionChange)="onCaseSelectionChanged($event.source.value)">
              {{getCaseDisplayString(caseDTO)}}
            </mat-option>
          </mat-autocomplete>
          <button *ngIf="caseNameFormControl.value"
                  mat-button mat-icon-button matSuffix
                  aria-label="Clear"
                  (click)="resetCaseRelatedFields()">
            <mat-icon style="color: grey;">clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      
      <!---------------------------->
      <!--  Related Transaction ID -->
      <!---------------------------->
      
      <ng-container *ngIf="showTransactionIdField">
        <div class="md-col md-col-12 m-b-15">
          <mat-form-field>
            <mat-label>Related Transaction ID</mat-label>
            <mat-select [formControl]="relatedTransactionIdFormControl" required
                        (selectionChange)="onTransactionIDSelectionChanged($event.source.value)">
              <mat-option *ngFor="let claim of filteredClaims"
                          [value]="getClaimDisplayString(claim)">
                {{getClaimDisplayString(claim)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
      <!---------------------------->
      <!--  From Bank Account -->
      <!---------------------------->
      <div class="md-col md-col-12 m-b-10">
        <mat-form-field>
          <mat-label>From Bank Account</mat-label>
          <mat-select [formControl]="fromBankAccountFormControl" required>
            <mat-option *ngFor="let bankAccount of fromBankAccounts"
                        [value]="getFromBankAccountDisplayString(bankAccount)">
              {{getFromBankAccountDisplayString(bankAccount)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!---------------------------->
      <!--  Payee -->
      <!---------------------------->
      <div class="md-col md-col-12 m-b-10">
        <mat-form-field>
          <mat-label>Payee</mat-label>
          <mat-select required [formControl]="payeeFormControl"
                      [compareWith]="compareProviders"
                      (selectionChange)="onPayeeSelectionChanged($event.source.value)">
            <mat-option *ngFor="let providerLink of providerLinks" [value]="providerLink.provider">
              {{getProviderDisplayString(providerLink.provider, providerLink.providerRole?.name)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-error *ngIf="isPayeeSelected() && !isBankAccountPresent()">Add bank account details for the payee
          <a class="text-underline hand-cursor" (click)="openProviderBankAccountDialog()">here</a>
        </mat-error>
        <br>
      </div>

      <!---------------------------->
      <!-- Amount -->
      <!---------------------------->
      <div class="md-col md-col-12 m-b-10">
        <mat-form-field>
          <mat-label>{{amountHeading()}}</mat-label>
          <input required [min]="0" [max]="maxAmount" [formControl]="amountFormControl"
                 thousandSeparator="," (blur)="onBlurAmountEntered()" type="number" matInput>
        </mat-form-field>
        <mat-error style="white-space: initial" *ngIf="showAmountWarning">{{amountWarning}} See
          <a class="text-underline hand-cursor" (click)="openHospitalCase()">case {{selectedCase.caseDTO.caseId}}</a>.
        </mat-error>
      </div>

      <!---------------------------->
      <!-- Immediate Payment -->
      <!---------------------------->
      <div class="md-col md-col-12 m-b-10">
        <mat-slide-toggle [formControl]="isImmediateFormControl">
          Is this an immediate payment?
        </mat-slide-toggle>
      </div>

      <!---------------------------->
      <!-- Informational Message -->
      <!---------------------------->
      <div class="md-col md-col-12 m-b-10">
        <label *ngIf="showInformationMessage"
               class="mat-primary-color font-small">
          The specified amount will be deducted from the next payment to the relevant payee
        </label>
      </div>
    </div>
  </div>


  <!-------------------------------------->
  <!-- Action Buttons Section-->
  <!-------------------------------------->

  <mat-dialog-actions align="center" class="dialog-button-container flex">
    <div [ngClass]="{'sm-col-12 md-col-4': isEdit}">
      <button class="dialog-button" mat-raised-button [mat-dialog-close]="false" color="warn">Cancel</button>
    </div>
    <div [ngClass]="{'sm-col-12 md-col-4': isEdit}">
      <button class="dialog-button" mat-raised-button color="primary" (click)="onClickSave()"
              [disabled]="disableSaveButton()">
        Save
        <mat-icon *ngIf="disableSaveButton()" class="info-icon"
                  [matTooltip]="disabledSaveTooltipMessage()">
          help_outline
        </mat-icon>
      </button>
    </div>
    <div *ngIf="isEdit" class="sm-col-12 md-col-4">
      <button class="dialog-button" mat-raised-button color="primary"
              (click)="onGenerateClick()"
              [disabled]="disableGenerateButton()">
        Generate
        <mat-icon *ngIf="disableGenerateButton()" class="info-icon"
                  [matTooltip]="disabledGenerateTooltipMessage()">
          help_outline
        </mat-icon>
        <mat-icon *ngIf="!disableGenerateButton()" class="info-icon"
                  [matTooltip]="'Save any changes first before generating'">
          warning
        </mat-icon>
      </button>
    </div>
  </mat-dialog-actions>
  <br/><br/>

  <div *ngIf="isEdit && !disableGenerateButton()">
    <mat-radio-group aria-label="Select an option"
                     class="flex flex-column radio-group"
                     [(ngModel)]="selectedReportType">
      <mat-radio-button *ngFor="let reportType of reportTypes"
                        [value]="reportType">
        {{reportType}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
